<span style="height: 100vh; background-color: yellow">
  <router-outlet></router-outlet>
</span>
